import React from "react";
import { motion } from "framer-motion";
import { Reveal } from "./motion";
import { JOURNEY } from "./content";

export default function VWModel() {
  return (
    <section
      className="vw-section bg-[var(--vw-navy)] text-white relative overflow-hidden"
      data-testid="model-section"
    >
      <div className="vw-grid-bg" />
      <div className="vw-noise" />

      <div className="vw-container relative">
        <Reveal>
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
            <div className="max-w-3xl">
              <div className="vw-overline vw-overline--gold mb-4">The Verified Workforce Model</div>
              <h2 className="font-display text-4xl lg:text-6xl font-semibold tracking-tight leading-[1.02]">
                An ecosystem built around the Delivery Partner.
              </h2>
            </div>
            <p className="max-w-md text-white/70 text-base leading-relaxed">
              We don&apos;t just introduce contractors. We identify, develop, verify, connect,
              support and monitor — building long-term supply-chain capability.
            </p>
          </div>
        </Reveal>

        <div className="relative">
          <div className="hidden lg:block absolute left-0 right-0 top-[46px] h-px bg-white/15" />
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5">
            {JOURNEY.map((j, i) => (
              <motion.div
                key={j.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
                className="relative"
                data-testid={`journey-step-${j.title.toLowerCase()}`}
              >
                <div className="relative z-10 mx-auto w-14 h-14 flex items-center justify-center bg-[var(--vw-navy)] border-2 border-[var(--vw-gold)] text-[var(--vw-gold)] font-mono text-sm">
                  0{i + 1}
                </div>
                <div className="mt-5 text-center lg:text-left">
                  <div className="font-display text-xl font-medium tracking-tight text-white uppercase">
                    {j.title}
                  </div>
                  <p className="mt-2 text-sm text-white/60 leading-relaxed">{j.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        <Reveal delay={0.1}>
          <div className="mt-16 pt-10 border-t border-white/10 grid md:grid-cols-3 gap-8 text-sm text-white/70">
            <div>
              <div className="font-mono text-[11px] tracking-[0.22em] text-[var(--vw-gold)] mb-2">
                PROPOSITION
              </div>
              <p>
                Verified Workforce is building infrastructure around the SME construction
                supply chain — identifying capability, developing readiness and connecting
                it with opportunity.
              </p>
            </div>
            <div>
              <div className="font-mono text-[11px] tracking-[0.22em] text-[var(--vw-gold)] mb-2">
                PRINCIPLE
              </div>
              <p>
                Good contractors shouldn&apos;t miss good opportunities because of
                compliance or commercial gaps. We help bridge them.
              </p>
            </div>
            <div>
              <div className="font-mono text-[11px] tracking-[0.22em] text-[var(--vw-gold)] mb-2">
                PARTNERSHIP
              </div>
              <p>
                Specialist partners such as Citation and Apollo Business Finance support
                parts of our ecosystem. Verified Workforce remains the primary relationship.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
